module.exports = __webpack_public_path__ + "static/media/EVOLUTION-GAMING-min.142469c6.webp";